// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1RVmg","range":"MonthRangeSwitch_range__1UsPY","disabled":"MonthRangeSwitch_disabled__UQFoP"};